export default __webpack_public_path__ + "static/settingwall-62a621d3c35fb49ff20d6ed6d7d81746.png";